import { createSlice } from '@reduxjs/toolkit';

export const counterSlice = createSlice({
  name: 'onBoarding',
  initialState: {
    isOnBoarding: false,
    onBoardingSteps: 1,
    isTipsForBestResults: false
  },
  reducers: {
    setIsOnBoarding: (state, action) => {
      state.isOnBoarding = action.payload;
    },
    setOnBoardingSteps: (state, action) => {
      state.onBoardingSteps = action.payload;
    },
    setIsTipsForBestResults: (state, action) => {
      state.isTipsForBestResults = action.payload;
    }
  }
});

export const { setIsOnBoarding, setOnBoardingSteps, setIsTipsForBestResults } =
  counterSlice.actions;

export default counterSlice.reducer;
